import './styles/tailwind.css';
import './styles/index.css';
import './index.css'
import Header from "./components/Header";
import Hero from "./components/Hero";
import Case from "./components/Case";
import Summary from './components/Summary';
import Stuffs from './components/Stuffs';
import Contact from './components/Contact';


function App() {
  return (
   <div className='w-full'>
    <Header/>
    <Hero/>
    <Case/>
    <Summary/>
    {/* <Stuffs/> */}
    <Contact/>
   </div>
  );
}

export default App;
